import React from 'react';

import styled from 'styled-components';

import {
  ButtonIcon,
  IconHelpAlt,
  Tooltip,
  Type,
} from '@spotify-internal/encore-creator-web';
import { white } from '@spotify-internal/encore-foundation';
import { TooltipTrigger } from '@mrkt/features/TooltipTrigger';

const Header = styled.header`
  align-items: flex-start;
  color: ${white};
  display: flex;
  justify-content: space-between;
`;

const Heading = styled(Type).attrs({
  as: Type.h3,
  color: white,
  variant: Type.heading4,
  weight: Type.bold,
})`
  padding-right: 10px;
`;

const HeadingAndTooltip = styled.span`
  display: flex;
`;

export function Title(props: { children?: React.ReactElement }) {
  return (
    <Header>
      <HeadingAndTooltip>
        <Heading>Artist Fundraising Pick</Heading>

        <HeadingTooltip />
      </HeadingAndTooltip>

      {props.children}
    </Header>
  );
}

const ButtonIconMarginBottom = styled(ButtonIcon)`
  margin-bottom: 1em;
`;

function HeadingTooltip() {
  return (
    <TooltipTrigger
      tooltip={
        <Tooltip theme={Tooltip.darkTheme}>
          Artist Fundraising Pick links fans to a fundraising destination of
          your choice. Only appears on the Spotify mobile app. Desktop coming
          soon.
        </Tooltip>
      }
      placement="topLeft"
      tooltipId="profile-artist-fundraising-pick-help"
    >
      <ButtonIconMarginBottom>
        <IconHelpAlt
          aria-label="artist fundraising pick help"
          focusable={false}
          iconSize={24}
        />
      </ButtonIconMarginBottom>
    </TooltipTrigger>
  );
}
